import { Navbar, Whatweb3, Footer } from '../containers';

const Web3 = () => {
  return (
    <div>
        <div className="Web3">
          <Navbar />
          <Whatweb3 />
          <Footer />
        </div>
    </div>
  )
}

export default Web3